<template>
  <div class="student-user-container">
    <div class="banner">
      <div class="banner-img">
        <img src="@/assets/images/banner/banner_9.png" alt="" />
      </div>
    </div>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/list' }"
          >满分学堂</el-breadcrumb-item
        >
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row>
        <el-col :span="6">
          <div class="c-left">
            <div class="info">
              <div class="head-top-box">
                <img :src="userInfo.head_img" class="head-img" />
                <img
                  :src="userInfo.frame_img"
                  class="frame-img"
                  v-if="userInfo.frame_img"
                />
              </div>
              <div class="info-list-box">
                <div class="info-list">
                  <span class="text-inline-block title">满分姓名：</span>
                  <span class="text-inline-block name" v-if="userInfo.u_name">{{
                    userInfo.u_name
                  }}</span>
                  <span
                    class="text-inline-block name"
                    @click="onEditName"
                    v-else
                  >
                    <el-link type="primary" icon="el-icon-edit"
                      >添加真实姓名</el-link
                    ></span
                  >
                </div>
                <div class="info-list">
                  <span class="text-inline-block title">满分帐号：</span>
                  <span class="text-inline-block name">{{
                    userInfo.u_guid
                  }}</span>
                </div>
                <div class="info-list">
                  <span class="text-inline-block title">当前班级：</span>
                  <span class="text-inline-block name">{{
                    userInfo.class_code
                  }}</span>
                </div>
                <div class="info-list">
                  <span class="text-inline-block title">班主任：</span>
                  <span class="text-inline-block name">{{
                    userInfo.teacher_name
                  }}</span>
                </div>
                <div class="info-list">
                  <span class="text-inline-block title">满分等级：</span>
                  <span class="text-inline-block name"
                    >Lv{{ userInfo.level }}</span
                  >
                </div>
                <div class="info-list">
                  <span class="text-inline-block title">满分称号：</span>
                  <span class="text-inline-block name">{{
                    userInfo.level_name
                  }}</span>
                </div>
                <div class="info-list">
                  <span class="text-inline-block title">家长帐号：</span>
                  <span
                    class="text-inline-block name"
                    v-if="userInfo.patriarch_account"
                    >{{ userInfo.patriarch_account }}</span
                  >
                  <span
                    class="text-inline-block name"
                    @click="onEditPatriarch"
                    v-else
                  >
                    <el-link type="primary" icon="el-icon-edit"
                      >激活帐号</el-link
                    ></span
                  >
                </div>
              </div>
            </div>
            <div class="tab-item item1" @click="getProps(1)">头像设置</div>
            <div class="tab-item item2" @click="getProps(2)">相框设置</div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="c-center">
            <div
              class="chunk1 chunk-center-top chunk-center"
              @click="onWeaknesses()"
            >
              <div class="msg">作业情况，弱科分析</div>
              <div class="title">学情分析</div>
              <img
                src="../../assets/images/user/icon-3.png"
                class="chunk-icon"
                alt=""
              />
            </div>
            <div
              class="chunk2 chunk-center-bottom chunk-center"
              @click="onAccount"
            >
              <div class="msg">星币账目</div>
              <div class="title">学习财富</div>
              <img
                src="../../assets/images/user/icon-1.png"
                class="chunk-icon"
                alt=""
              />
            </div>
            <div
              class="chunk5 chunk-center-bottom chunk-center-min"
              @click="onUserNote"
            >
              <div class="chunk-text5">随堂笔记导出</div>
              <img
                src="../../assets/images/user/icon-5.png"
                class="chunk-icon-min"
                alt=""
              />
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="c-right">
            <div class="top chunk3 chunk" @click="onConversion">
              <div class="msg">道具，虚拟物品</div>
              <div class="title">兑换中心</div>
              <img
                src="../../assets/images/user/icon-4.png"
                class="chunk-icon"
                alt=""
              />
            </div>
            <div class="bottom chunk4 chunk" @click="onNews">
              <div class="msg">班级消息，系统消息</div>
              <div class="title">消息通知</div>
              <div class="msg-num">{{ messageCount }}</div>
              <img
                src="../../assets/images/user/icon-2.png"
                class="chunk-icon"
                alt=""
              />
            </div>
            <div class="chunk6 bottom chunk-center-min" @click="isCouserNote = true">
              <div class="chunk-text5">看课历史数据</div>
              <img
                src="../../assets/images/user/icon-6.png"
                class="chunk-icon-min"
                alt=""
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.status"
      width="1130px"
    >
      <div class="dialog-box">
        <div class="dialog-left">
          <div
            class="dialog-item dialog-left-item1"
            :class="{ dialoged: dialog.types === 1 }"
            @click="getProps(1)"
          >
            <div class="dialog-left-title">已获得的头像</div>
            <img
              src="../../assets/images/1.png"
              class="dialog-sign"
              alt=""
              v-if="dialog.types == 1"
            />
          </div>
          <div
            class="dialog-item dialog-left-item2"
            :class="{ dialoged: dialog.types === 2 }"
            @click="getProps(2)"
          >
            <div class="dialog-left-title">已获得的相框</div>
            <img
              src="../../assets/images/1.png"
              class="dialog-sign"
              alt=""
              v-if="dialog.types == 2"
            />
          </div>
        </div>
        <div class="dialog-right">
          <ul class="dialog-right-ul">
            <GeminiScrollbar class="dialog-center" v-if="dialog.types == 1">
              <li
                class="dialog-right-li"
                :class="{ active: item.use_status === 1 }"
                v-for="(item, index) in propsList"
                :key="index"
                @click="onSetProps(item, 1)"
              >
                <div class="img-chunk">
                  <img :src="item.props.img_url" class="dialog-list-img" />
                </div>
              </li>
            </GeminiScrollbar>
            <GeminiScrollbar class="dialog-center" v-if="dialog.types == 2">
              <li
                class="dialog-right-li "
                :class="{ active: item.use_status === 1 }"
                v-for="(item, index) in propsList"
                :key="index"
                @click="onSetProps(item, 2)"
              >
                <div class="img-chunk">
                  <img :src="item.props.img_url" class="dialog-list-img" />
                </div>
              </li>
            </GeminiScrollbar>
          </ul>
          <div class="conversion-box">
            <el-link
              type="primary"
              :underline="false"
              class="conversion"
              @click="onConversion"
              >前往兑换中心>>></el-link
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="我的财富" :visible.sync="isAccount" width="930px">
      <Accounts></Accounts>
    </el-dialog>
    <el-dialog title="笔记列表" :visible.sync="isUserNote" width="930px">
      <user-note @closeCallBack="onCloseCallBack"></user-note>
    </el-dialog>
    <el-dialog title="课程学习记录" :visible.sync="isCouserNote" width="1000px">
      <course-history></course-history>
    </el-dialog>
  </div>
</template>
<script>
// import md5 from 'js-md5';
import "../../assets/css/dialog.css";
import Accounts from "../template/Accounts.vue";
import CourseHistory from '../template/CourseHistory.vue';
import UserNote from "../template/UserNote.vue";
export default {
  components: { Accounts, UserNote, CourseHistory },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 100,
      },
      pageTotal: 0,
      dialog: { title: "已获道具列表", status: false, types: 1 },
      userInfo: {},
      propsList: [],
      isAccount: false,
      isUserNote: false,
      isCouserNote: false,
      messageCount: 0,
    };
  },
  created() {
    this.getMessageCount();
    this.getUserInfo();
  },
  methods: {
    getMessageCount() {
      this.getRequest("/wenjiaoopne/kc/students/getMessageCount")
        .then((result) => {
          this.messageCount = result.data;
        })
        .catch(() => {});
    },
    getUserInfo() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/user/getStudentInfo")
        .then((result) => {
          this.loading.close();
          this.userInfo = result.data;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getProps(_types) {
      this.getRequest(
        "/wenjiaoopne/kc/userProps/propsList",
        Object.assign(this.query, { types: _types })
      )
        .then((result) => {
          this.propsList = result.data.list;
          this.pageTotal = result.data.page_total;
          this.dialog.status = true;
          this.dialog.types = _types;
        })
        .catch(() => {});
    },
    onEditPatriarch() {
      this.getRequest("/wenjiaoopne/kc/patriarch/create")
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error("激活失败");
            return false;
          }
          this.$alert(
            `您家长帐号的初始密码：${result.data.password}`,
            "家长帐号激活成功",
            {
              confirmButtonText: "确定",
              callback: () => {
                this.$set(
                  this.userInfo,
                  "patriarch_account",
                  result.data.user_account
                );
              },
            }
          );
        })
        .catch(() => {
          this.loading.close();
        });
    },
    onSetProps(item, types) {
      this.getRequest("/wenjiaoopne/kc/userProps/setUserProps", {
        props_id: item.props_id,
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.getProps(types);
          if (types === 1) {
            this.$set(this.userInfo, "head_img", item.props.img_url);
          } else {
            this.$set(this.userInfo, "frame_img", item.props.img_url);
          }
          this.$message.success(result.message);
        })
        .catch(() => {});
    },
    onUserNote() {
      this.isUserNote = true;
    },
    onAccount() {
      this.isAccount = true;
    },
    onConversion() {
      this.$router.push("/conversion");
    },
    onWeaknesses() {
      this.$router.push("/student/weaknesses");
    },
    onNews() {
      this.$router.push("/student/news");
    },
    onEditName() {
      this.$prompt("请输入真实姓名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "姓名不能为空",
        inputValue: this.userInfo.u_name,
      })
        .then(({ value }) => {
          this.postRequest("/wenjiaoopne/kc/user/setName", { u_name: value })
            .then(() => {
              this.$set(this.userInfo, "u_name", value);
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onInit() {
      this.$message.error("暂未开放");
      return false;
    },
    onCloseCallBack(v) {
      this.isUserNote = v;
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.student-user-container {
  background-color: #f1f1f1;
}
.student-user-container .banner {
  width: 100%;
  /* height: 173px; */
  background-image: url("../../assets/images/banner/bg_9.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.student-user-container .banner-img {
  width: 1195px;
  margin: 0 auto;
  height: inherit;
}
.student-user-container .banner-img > img {
  width: 100%;
  height: 100%;
}
.student-user-container .content {
  position: relative;
  width: 1195px;
  height: 610px;
  margin: 0 auto;
}

.student-user-container .left-container .item {
  position: relative;
  display: block;
  height: 130px;
  margin: 2px 0;
  text-align: center;
  line-height: 130px;
  background-color: #40b8ee;
  font-size: 21px;
  color: #fff;
}
.student-user-container .left-container .item > .icon {
  position: absolute;
  right: 0;
  top: 44px;
}

.student-user-container .content::after {
  content: "";
  display: block;
  clear: both;
}
.student-user-container .breadcrumb {
  height: 50px;
  line-height: 50px;
  color: #36486e;
}
.student-user-container .c-left {
  position: relative;
  width: 100%;
  height: 430px;
}
.student-user-container .c-left .info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 430px;
  background: #263d6f;
  z-index: 2;
  box-shadow: 0px 1px 10px #263d6f61;
}
.student-user-container .info .head-top-box {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 5px auto 5px auto;
}
.student-user-container .info .head-top-box > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.student-user-container .info .head-top-box .head-img {
  border-radius: 50%;
  z-index: 2;
}
.student-user-container .info .head-top-box .frame-img {
  z-index: 1;
}
.info-list-box {
  width: 100%;
}
.info-list-box .info-list {
  width: 205px;
  margin: 10px auto;
}
.info-list-box .text-inline-block {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.info-list-box .title {
  color: #9cc2f4;
  width: 80px;
  text-align: right;
}
.info-list-box .name {
  width: 125px;
  color: #fff;
}
.student-user-container .tab-item {
  bottom: -55px;
  width: 100px;
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  position: absolute;
  background-color: #b9e3fe;
  transform: rotate(-60deg);
  color: #4abff0;
  z-index: 1;
  cursor: pointer;
}
.student-user-container .chunk1 {
  background-color: #d13d71;
}
.student-user-container .chunk2 {
  background-color: #445db7;
}
.student-user-container .chunk3 {
  background-color: #fba443;
}
.student-user-container .chunk4 {
  background-color: #40b8ee;
}
.student-user-container .chunk5 {
  background-color: #6a8aff;
}
.student-user-container .chunk6 {
  background-color: #6bd2ff;
}
.student-user-container .chunk-center {
  position: relative;
  width: 94%;
  height: 205px;
  box-shadow: 0px 1px 10px #263d6f61;
  cursor: pointer;
}
.student-user-container .chunk {
  position: relative;
  width: 94%;
  height: 205px;
  box-shadow: 0px 1px 10px #263d6f61;
  cursor: pointer;
}
.student-user-container .chunk .msg,
.student-user-container .chunk-center .msg {
  width: 90%;
  padding: 50px 0;
  text-align: right;
  font-size: 18px;
  color: #fff;
}
.student-user-container .chunk .title,
.student-user-container .chunk-center .title {
  width: 90%;
  text-align: right;
  font-size: 30px;
  color: #fff;
}
.student-user-container .chunk-center-min {
  position: relative;
  width: 94%;
  height: 90px;
  border-radius: 3px;
  box-shadow: 0px 1px 10px #263d6f61;
  cursor: pointer;
}
.student-user-container .chunk-text5 {
  position: absolute;
  right: 28px;
  top: 33px;
  font-size: 18px;
  color: #fff;
}
.student-user-container .msg-num {
  position: absolute;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 50%;
  right: 15px;
  bottom: 70px;
  background-color: #fff;
  color: #30a6cb;
}
.student-user-container .chunk-icon {
  position: absolute;
  left: 45px;
  bottom: 20px;
  width: 109px;
  height: 89px;
}
.student-user-container .chunk-icon-min {
  position: absolute;
  left: 30px;
  bottom: 20px;
  width: 210px;
}

.student-user-container .top {
  margin: 0 auto;
}
.student-user-container .bottom {
  margin: 20px auto 0;
}

.student-user-container .chunk-center-top {
  margin-left: 20px;
}
.student-user-container .chunk-center-bottom {
  margin: 20px auto 0 20px;
}
.student-user-container .item1 {
  left: 0px;
}
.student-user-container .item2 {
  left: 75px;
}
.student-user-container .dialog-box {
  position: relative;
  width: 100%;
  height: 445px;
}
.student-user-container .dialog-box .dialog-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 170px;
  height: 448px;
}
.student-user-container .dialog-box .dialog-left .dialog-item {
  position: relative;
  width: 100%;
  height: 222px;
  cursor: pointer;
  background-color: #30a6cb;
}
.student-user-container .dialoged {
  background-color: #fba443 !important;
}
.student-user-container .dialog-left-item2 {
  border-top: 1px solid #fba443;
}
.student-user-container .dialog-left-title {
  width: 20px;
  text-align: center;
  margin: 0 auto;
  padding-top: 40px;
  color: #fff;
  font-size: 18px;
}
.student-user-container .dialog-right {
  padding-left: 190px;
  height: 445px;
  background-color: #edf8fe;
}
.student-user-container .dialog-right-ul {
  padding-top: 20px;
}
.student-user-container .dialog-right .dialog-right-li {
  float: left;
  width: 164px;
  height: 164px;
  margin: 10px 10px;
  background-color: #fff;
  cursor: pointer;
}
.student-user-container .dialog-right .dialog-right-li:hover {
  width: 164px;
  height: 164px;
  background-image: url("../../assets/images/user/4.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.student-user-container .dialog-list-img {
  width: 160px;
  height: 160px;
}
.student-user-container .dialog-right .active {
  width: 164px;
  height: 164px;
  background-image: url("../../assets/images/user/3.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.student-user-container .dialog-right-ul .dialog-center {
  height: 370px;
}
.student-user-container .dialog-sign {
  position: absolute;
  right: -1px;
  top: 90px;
}
.student-user-container .conversion-box {
  text-align: right;
}
.student-user-container .conversion {
  margin-right: 30px;
}
.c-213652 {
  color: #213652;
}
.c-b1d8e8 {
  color: #b1d8e8;
}
.c-ff8d41 {
  color: #ff8d41;
}
.c-d43557 {
  color: #d43557;
}
.c-30a6cb {
  color: #30a6cb;
}
.c-425389 {
  color: #425389;
}
</style>
